<p-dialog header="Reportar un error" [(visible)]="visible" [modal]="true" [style]="{width: '500px'}">
  <form [formGroup]="form" class="space-y-4">
    <div>
      <label class="block mb-1 text-sm font-medium">Título del problema</label>
      <input pInputText formControlName="titulo" class="w-full"/>
    </div>
    <div>
      <label class="block mb-1 text-sm font-medium">Descripción</label>
      <textarea pTextarea formControlName="descripcion" rows="4" class="w-full"></textarea>
    </div>
    <div>
      <label class="block mb-1 text-sm font-medium">Adjuntar archivo</label>
      <p-fileUpload mode="basic" name="file[]" chooseLabel="Seleccionar archivo"></p-fileUpload>
    </div>
  </form>

  <ng-template pTemplate="footer">
    <p-button label="Cancelar" icon="pi pi-times" (click)="cerrar()" styleClass="p-button-text"/>
    <p-button label="Enviar" icon="pi pi-check" (click)="enviar()" [disabled]="form.invalid"/>
  </ng-template>
</p-dialog>
